exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___3N4nq {\n  padding: 24px 20px 20px;\n}\n.tabsContainer___2dJ43 {\n  display: flex;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n}\n.tab___3t2qL {\n  text-align: center;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  flex: 1 1 50%;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  border-bottom: 3px solid transparent;\n  background-color: #ffffff;\n  height: 50px;\n  color: #767676;\n}\n.tab___3t2qL.active___b1lv9 {\n  color: #21201f;\n  border-bottom-color: #0075ae;\n}\n.hide___2D83a {\n  display: none;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___3N4nq",
	"tabsContainer": "tabsContainer___2dJ43",
	"tab": "tab___3t2qL",
	"active": "active___b1lv9",
	"hide": "hide___2D83a"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionMobileContainer/ConfigureAddressCollectionMobileContainer.module.less
// module id = 2353
// module chunks = 71